<template>
  <div>
    <DataTable :value="afastamentos" :filters="filtro" :paginator="true" :rows="10"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
        class="p-datatable-sm p-datatable-striped">
        <template #header>
            <div class="table-header">	
               <div class="p-d-flex p-jc-end">				
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText v-model="filtro['global']" placeholder="Filtrar..." />
                    </span>
                </div>
            </div>
        </template>
        <Column field="motivo.descricao" header="Motivo"></Column>
         <Column field="motivo.definitivo" header="Definitivo">
            <template #body="slotProps">               
                {{slotProps.data.motivo.definitivo ? 'Sim' : 'Não'}}
            </template>
        </Column>     
        <Column field="dataInicio" header="Data início"></Column>
        <Column field="dataFinal" header="Data final"></Column>	  
    </DataTable>

    <Button label="Fechar" class="p-button-secondary p-mt-3" icon="pi pi-times" @click="cancelar"/>

  </div>
</template>

<script>

export default {
    data() {
        return {       
            afastamentos: [],         
            filtro: {},
        }
    },
    methods: {   
        carregar(afastamentos) {
            this.afastamentos = afastamentos;
        },
        cancelar() {
            this.$router.push('/cadastros/funcionarios');
        },
    }
}
</script>

<style>

</style>